import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FeeProcessComponent } from '../fee-process/fee-process.component';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { PaymentReceiptComponent } from '../payment-receipt/payment-receipt.component';

@Component({
  selector: 'app-apply-fee-template',
  templateUrl: './apply-fee-template.component.html',
  styleUrls: ['./apply-fee-template.component.scss']
})
export class ApplyFeeTemplateComponent implements OnInit {

  APIService: any;
  ApplyFee: FormGroup;
  sessionList: any[];
  SessionFilterList: any[];
  FeeTable: [];
  sessionId = 0;
  CoCode : any;
  CgCode = 0;
  CourseList: any;
  filteredListCourse: any;
  collegeList: any;
  filteredCollegeList: any;
  payBtnShow = false;
  PayLater = true
  StudentType: '';
  StudentStatus: '';
  Constitution: '';
  Social: '';
  Admission: '';
  Caste: '';
  FeePaid: any;
  Table = false;
  feeApplyArray: FormArray;
  constId = 0;
  StuData: any;
  TempCode: any;
  studentId: any;
  Mode: any;
  dialogRef1: MatDialogRef<any>;
  SessionNo: any;
  ADMRecords: any[];
  Dates: any[];
  ShowMsg = false; 
  Message = '';
  PayStatus: any;
  Paylater: any;
  FeeDetails: any;
  userPermission: any;
  UserCollege: any;
  updateBtn=false;
  constructor(private dialog: MatDialog,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private spinner: NgxSpinnerService, private cdr: ChangeDetectorRef
  ) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    this.ShowMsg = false;
    this.PayLater = true
    this.Message = '';
    // below if else condition to decide which session
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    if (JSON.parse(sessionStorage.getItem("session")) == null) {
      this.fetchSecretData();
    }
    else if (JSON.parse(sessionStorage.getItem("session")) != null) {
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo;
    }
    this.Table = false;
    this.payBtnShow = false;
    let id = ''
    this.StudentType = '';
    this.StudentStatus = '';
    this.Constitution = '';
    this.Social = '';
    this.Admission = '';
    this.Caste = '';
    this.sessionId = 0;
    this.constId = 0;
    this.ApplyFee = this.fb.group({
      college: new FormControl(''),
      course: new FormControl(''),
      SessionId: new FormControl(''),
      feeApplyArray: new FormArray([]),
    });
    this.fetchSession(id);  //this function for session dropdown data
  }

  fetchSecretData() {
    this.spinner.show()
    this.umsService.getSecretData().subscribe((res) => {
      if(res.status){
        this.spinner.hide()
        this.SessionNo = res.projectPharam['SnNo']
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    }
    );
  }

  fetchSession(id) {
    this.spinner.show()
    const payload = {};
    payload['SnDefault'] = id;
    payload['SnNo'] = id;
    this.umsService.getSession(payload).subscribe(res => {
      this.sessionList = [];
      if (res.status) {
        this.spinner.hide()
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  getfeeApplyArrayControls() {
    return (this.ApplyFee.get('feeApplyArray') as FormArray).controls;
  }

  getCourse(id) {
    this.spinner.show();
    this.Table = false;
    this.sessionId = id
    this.collegeList = [];
    this.filteredCollegeList = [];
    const payload = {};
    payload['SessionId'] = id;
    sessionStorage.setItem("SnNo", id);
    this.umsService.fetchIntakeFilter(payload).subscribe(res => {
      if(res.status){
        this.spinner.hide()
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
        this.ApplyFee.controls['course'].setValue('')
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  getClg(CoCode) {
    this.spinner.show();
    this.Table = false;
    this.CoCode = CoCode;
    this.collegeList = [];
    // this commeted bcoz tester said they want couse wise college form mapping
    // if(this.userPermission[0].CgUi == 'C'){
    //   this.UserCollege= this.userPermission[0].CgId;
    // }
    // else{
    //   this.UserCollege = ''
    // }
    const payload = {};
    // payload['SessionId'] = this.sessionId;
    // payload['CoCgCoCode'] = CoCode;
    payload['CoCode'] = CoCode
    this.umsService.fetchstucourseClgMap(payload).subscribe(res => {
      if(res.status){
        this.collegeList = res.data;
        this.filteredCollegeList = this.collegeList.slice();
        this.ApplyFee.controls['college'].setValue('')
        this.spinner.hide()
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  ShowTable(CgCode) {
    this.spinner.show();
    this.CgCode = CgCode;
    this.feeApplyArray = this.ApplyFee.get('feeApplyArray') as FormArray;
    this.feeApplyArray.clear();
    sessionStorage.setItem("college", CgCode);
    sessionStorage.setItem("course",this.CoCode)
    const payload = {};
    payload['StuId'] = 0;
    payload['SessionId'] = this.sessionId;
    payload['CoCode'] = this.CoCode;
    payload['CgCode'] = CgCode;
    payload['FeeType'] = 'AF';
    this.umsService.SearchFeeAdm(payload).subscribe((res) => {
      if (res.status) {
       this.spinner.hide();
        this.getFeeModeData();
        this.FeeTable = res.data;
        this.studentId = res.data.StuId;
        this.FeeTable.forEach((element, i) => {
          const creds = this.ApplyFee.controls.feeApplyArray as FormArray;
          creds.push(
            this.fb.group({
              StudentName: new FormControl(element['StuFirstNameEng'] + " " + element['StuMidNameEng'] + " " + element['StuLastNameEng']),
              TemplateName: new FormControl(element['TemplateName']),
              StuType: new FormControl(),
              StuStatus: new FormControl(),
              StuSocial: new FormControl(),
              StuAdm: new FormControl(),
            })
          );
          //to show the full name in place of code received from response all below apis are called
          this.getStudentType(element['StudentType'], i)
          this.getStudentStatus(element['StudentStatus'], i);
          this.getSocial(element['SocialReservation'], i);
          this.getAdmission(element['AdmissionMode'], i);
          //to get the data of fees paid
          this.SearchFeeDetails(element['TemplateCode'], element['StuId'])
        });

      } else {
        this.PayLater = true
        if (res.message == 'No Data Found') {
          this.Table = false;
          this.PayLater = true
          this.FeeTable = [];
        }
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });

  }

  getFeeModeData() {
    this.spinner.show();
    const payload = {};
    payload["Session"] = this.sessionId;
    payload['College'] = this.CgCode,
      this.umsService.fetchCheckFeeMode(payload).subscribe(res => {
        if(res.status){
          this.spinner.hide();
          this.Mode = res.data[0]['FeeMode']
          this.payBtnShow = true;
          this.Table = true;
          this.PayLater = false
        }
        else{
          this.spinner.hide()
          let data = {};
          data['message'] = 'Add Fee Mode For This Filter!';
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.Table = false;
          this.PayLater = false
        }
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide()
      });
  }

  checkLock2(item) {  //this api is called so that if scrutiny not approved yet then admin should not be able to pay fees
    this.spinner.show()
    const payload = {};
    payload['UserId'] = sessionStorage.getItem('userId');
    payload['StudentId'] = item.StuId;
    payload['SessionId'] = this.sessionId;
    this.umsService.ScrutinyLock(payload).subscribe((res) => {
      if (res.status) { //if scrutiny approval is done then you can open Payment popup
        this.spinner.hide()
        let Data = res.data[0]
        if (Data.FinalApproval == true) {
          this.openFeeProcessPopUp(item)
        }
        else if (Data.FinalApproval != true) {
          let data = {};
          data['message'] = 'Scrutiny Not Approved';
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }

      } else {
        this.spinner.hide()
        let data = {};
        data['message'] = 'Scrutiny Not Approved';
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });

  }

  openFeeProcessPopUp(item) {
    let data = {};
    data['TempCode'] = item.TemplateCode;
    data['StuId'] = item.StuId;
    data['Mode'] = this.Mode;
    data['SessionId'] = item.SessionId
    const dialogRef4 = this.dialog.open(FeeProcessComponent,
      {
        disableClose: true,
        width: "900px",
        height: 'auto',
        data
      });
      dialogRef4.afterClosed().subscribe((result) => {
      this.ShowTable(item.CgCode)
    });
  }

  getStudentType(id, i) {
    this.spinner.show()
    const payload = {};
    payload['CdType'] = 'STYPE'
    payload['CdCode'] = id;
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.StuData = res.data
        this.feeApplyArray = this.ApplyFee.get('feeApplyArray') as FormArray;
        this.StuData.map((element) => {
          this.feeApplyArray.at(i).get('StuType').setValue(element['CdDesc']);
        });
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  getStudentStatus(id, i) {
    this.spinner.show()
    const payload = {};
    payload['CdType'] = 'STUST'
    payload['CdCode'] = id;
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.StuData = res.data
        this.feeApplyArray = this.ApplyFee.get('feeApplyArray') as FormArray;
        this.StuData.map((element) => {
          this.feeApplyArray.at(i).get('StuStatus').setValue(element['CdDesc']);
        });
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  getSocial(id, i) {
    this.spinner.show()
    const payload = {};
    payload['CdType'] = 'SR'
    payload['CdCode'] = id;
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.StuData = res.data
        this.feeApplyArray = this.ApplyFee.get('feeApplyArray') as FormArray;
        this.StuData.map((element) => {
          this.feeApplyArray.at(i).get('StuSocial').setValue(element['CdDesc']);
        });
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  getConstitution(id) {
    this.spinner.show()
    this.constId = id;
    const payload = {};
    payload['CdType'] = 'CS'
    payload['CdCode'] = id;
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.Constitution = res.data[0]['CdDesc'];
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  getAdmission(id, i) {
    this.spinner.show()
    const payload = {};
    payload['CdType'] = 'AMODE'
    payload['CdCode'] = id;
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.StuData = res.data
        this.feeApplyArray = this.ApplyFee.get('feeApplyArray') as FormArray;
        this.StuData.map((element) => {
          this.feeApplyArray.at(i).get('StuAdm').setValue(element['CdDesc']);
        });
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  getCaste(id) {
    this.spinner.show()
    const payload = {};
    payload['CategoryId'] = this.constId;
    payload['CasteCode'] = id
    this.umsService.fetchCategory(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.Caste = res.data[0]['CasteName']
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  
  SearchFeeDetails(TempCode, StdId) {
    this.spinner.show();
    this.PayStatus = [];
    this.Paylater = [];
    const payload = {
      FeeTemplateCode: TempCode,
      StuId: StdId,
      FeeHistory: 0,
      SnNo: this.sessionId
    };
    try {
      this.umsService.getSearchFeeDetails(payload).subscribe((res) => {
        if (res.status) {
          this.spinner.hide();
          let data = 0;
          this.FeeDetails = res.data;
          res.data.forEach((element, i) => {
            data += element.FeeAmt;
          });
          const index = this.FeeTable.findIndex((student: any) => student.StuId === StdId);
        //   if (res.data[0]['TotalPaidAmount'] === 0 && data === 0) {
        //     this.updateBtn = true;
        //     this.PayStatus[index] = true;
        //     this.FeePaid = 'Wave Off'
        //   }
        //  else 
          if (data === res.data[0]['TotalPaidAmount']) {  //here if amount is paid PayStatus is true to show Paid Status
            this.PayStatus[index] = true;
            this.FeePaid = 'Fees Paid';
            this.updateBtn = false;
          } else if(res.data[0]['FeeStatus'] == 'N'){ //here if FeeStatus is N then Paylater is true to show PayLater Status
            this.Paylater[index] = true;
            this.PayStatus[index] = false;
            this.updateBtn = false;
          }
          else {  // else if above all conditions are false then pay button should be displayed so made both varibale false
            this.PayStatus[index] = false;
            this.Paylater[index] = false;
          }

        } else {
          this.spinner.hide();
          
          // Handle error response if needed
        }
      });
    } catch (error) {
      this.spinner.hide();
     
    }
  }


 
  
  submit() {
    this.spinner.show()
    let payload = {};
    this.ADMRecords = [];
    this.Dates = [];
    payload['SnNo'] = parseInt(this.SessionNo);
    this.umsService.listSessionCutOff(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        const courseRecords = res.data.filter(record => record.CoCgCoCode === sessionStorage.getItem("StuCoId") && record.CoCgCgCode === sessionStorage.getItem("StuCgId"));
        const today = new Date();
        const todayDateString = today.toISOString().split('T')[0];
        if (courseRecords.length > 0) {
          this.ADMRecords = courseRecords.filter(record => record.InCode === 'ADFEE');
        }
        const promises = this.ADMRecords.map(element => {
          let payload = {};
          payload['SessionID'] = element.SessionID;
          payload['CoCgCgCode'] = element.CoCgCgCode;
          payload['CoCgCoCode'] = element.CoCgCoCode;
          payload['InCode'] = element.InCode;
          return this.umsService.findSessionCutOff(payload).toPromise();
        });

        Promise.all(promises).then(results => {
          results.forEach(res => {
            this.Dates.push(...res.data);
          });

          let listCanOpen = false;
          if (this.Dates.length == 0) {
            this.showAlert('Schedule Not Open For This Activity');
            listCanOpen = false;
          }
          else if (this.Dates.length > 0) {
            for (let item of this.Dates) {
              if ((item.CutOffDateFrom.split('T')[0] === todayDateString && todayDateString < item.CutOffDate.split('T')[0]) || (item.CutOffDateFrom.split('T')[0] < todayDateString && todayDateString < item.CutOffDate.split('T')[0])) {
                listCanOpen = true;
                break;
              }
            }
          }


          if (!listCanOpen) {
            for (let item of this.Dates) {
              if (todayDateString > item.CutOffDate.split('T')[0]) {
                this.showAlert('Admission Fee Payment Dates Are Closed For This Course');
                break;
              } else if (todayDateString < item.CutOffDateFrom.split('T')[0]) {
                this.showAlert('Schedule Is Not Open For This Activity');
                break;
              }
            }
          }
          if (listCanOpen == true) {
            this.ShowMsg = false;
            this.Message = '';
          }
        }).catch(error => {
        });
      } else {
        this.spinner.hide()
        this.showAlert('First Enter CuttOff Dates For This Course Admission Fee');
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });

  }

  showAlert(message: string) {
    this.ShowMsg = true
    this.Message = message;
  }


  paymentReceipt(item) {
    sessionStorage.setItem('TemplateCode', item.TemplateCode);
    sessionStorage.setItem('StuId', item.StuId);
    let data = {};
    data['TempCode'] = item.TemplateCode;
    data['StuId'] = item.StuId;
    data['Mode'] = this.Mode;
    data['SessionId'] = item.SessionId
    const dialogRef = this.dialog.open(PaymentReceiptComponent, {
      width: '80vh',
      data: { key: "New",
      StuId: item.StuId,
      Session : item.SessionId
       },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
 
    });
  }

}
